export default __webpack_public_path__ + "static/media/comback-home.1e3a96e3.png";